import { render, staticRenderFns } from "./BindsFile.vue?vue&type=template&id=158ae17e&"
import script from "./BindsFile.vue?vue&type=script&lang=js&"
export * from "./BindsFile.vue?vue&type=script&lang=js&"
import style0 from "./BindsFile.vue?vue&type=style&index=0&id=158ae17e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports